export default function getWithDefault(key, getDefault) {
  var _this = this;

  return this.has(key) ? this.get(key) : function () {
    var defaultValue = getDefault();

    _this.set(key, defaultValue);

    return defaultValue;
  }();
}